export const GET_PLANETARY_RESULT = "GET_PLANETARY_RESULT";
export const GET_PLANETARY_RESULT_SUCCESS = "GET_PLANETARY_RESULT_SUCCESS";
export const GET_PLANETARY_RESULT_ERROR = "GET_PLANETARY_RESULT_ERROR";
export const RESET_PLANETARY_RESULT = "RESET_PLANETARY_RESULT";
